import {Hydra} from '../generic/hydra';

import {LocalisationInfoItemInterface} from './LocalisationInfoItem';
import {LocalisationInfo as LocalisationInfoBaseInterface} from '../../interface/api/LocalisationInfo';

export type LocalisationInfoInterface = LocalisationInfoBaseInterface;

export class LocalisationInfo extends Hydra implements LocalisationInfoInterface {

    id?: number | null;

    /* 0 = non applicable, 1 = toutes localisations, 2 = localisations specifiques
     */
    typeLocalisations?: number | null;

    cancerPrimitifs?: LocalisationInfoItemInterface[] | null = [];


    constructor(options: LocalisationInfoInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
